import React, { useState } from 'react';

const PrivacyPolicy = () => {
  const [agreed, setAgreed] = useState(false);
 const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(true); // Set to true initially if it should appear on load
  const handleCheckboxChange = (event) => {
    setAgreed(event.target.checked);
  };

  const handleSubmit = () => {
    if (agreed) {
      alert('Privacy Policy accepted!');
      // Here you would typically store the user's acceptance in local storage or send it to a backend.
    } else {
      alert('Please agree to the Privacy Policy to proceed.');
    }
  };
const handleClosePolicy = () => {
    setShowPrivacyPolicy(false);
  };
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      {/* <h1>Privacy Policy</h1>
      <p>
        No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
      </p>
   
    

      <div style={{ marginTop: '30px' }}>
        <input
          type="checkbox"
          id="agreeCheckbox"
          checked={agreed}
          onChange={handleCheckboxChange}
        />
        <label htmlFor="agreeCheckbox" style={{ marginLeft: '10px' }}>
          I have read and agree to the Privacy Policy.
        </label>
      </div>
      <button
        onClick={handleSubmit}
        disabled={!agreed}
        style={{ marginTop: '20px', padding: '10px 20px', cursor: agreed ? 'pointer' : 'not-allowed' }}
      >
        Accept Privacy Policy
      </button> */}


 {showPrivacyPolicy && (
        <div className="privacy-policy-overlay">
          <div className="privacy-policy-content">
            <h2>Privacy Policy</h2>
            <p>No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</p>
            <button onClick={handleClosePolicy}>Close</button>
          </div>
        </div>
      )}
      {/* Other parts of your application */}
      <button onClick={() => setShowPrivacyPolicy(true)}>View Privacy Policy</button>
    </div>
  );
};

export default PrivacyPolicy;